const ADD_CART_MAX_SIMPLES_PER_CONFIG = 501;
const ADD_CART_MAX_30_SIMPLES_IN_CART = 510;
const ADD_CART_MAX_SIMPLES_PER_CONFIG_REACHED_QTY_ADJUSTED = 502;
const ADD_CART_STOCK_NOT_FOUND = 503;
const ADD_CART_MAX_AVAILABLE_STOCK_REACHED_QTY_ADJUSTED = 504;
const ADD_CART_NOT_COMBINABLE_ADD_ITEM_NOT_COMBINABLE = 505;
const ADD_CART_SIZE_SELECTION_WARNING = 506;
const ADD_CART_VOUCHER_DISABLED = 507;
const ADD_CART_NOT_COMBINABLE_NOT_COMBINABLE_IN_CART = 508;
const ADD_CART_SIZE_SELECTION_ERROR = 509;

type ErrorCode =
    | typeof ADD_CART_MAX_SIMPLES_PER_CONFIG
    | typeof ADD_CART_MAX_SIMPLES_PER_CONFIG_REACHED_QTY_ADJUSTED
    | typeof ADD_CART_MAX_30_SIMPLES_IN_CART
    | typeof ADD_CART_STOCK_NOT_FOUND
    | typeof ADD_CART_MAX_AVAILABLE_STOCK_REACHED_QTY_ADJUSTED
    | typeof ADD_CART_NOT_COMBINABLE_ADD_ITEM_NOT_COMBINABLE
    | typeof ADD_CART_SIZE_SELECTION_WARNING
    | typeof ADD_CART_VOUCHER_DISABLED
    | typeof ADD_CART_NOT_COMBINABLE_NOT_COMBINABLE_IN_CART
    | typeof ADD_CART_SIZE_SELECTION_ERROR;

interface CartErrorItem {
    simpleSku: string;
    size: string;
}

interface AddToCartIncomingError {
    code: ErrorCode;
    message: string;
    details: null | {
        existingItems?: CartErrorItem[];
    };
}

interface AddToCartError {
    isSizeOverlayOpen: boolean;
    simplesInCart: CartErrorItem[];
    maximumQuantityOfArticleReached: boolean;
    stockNotFound: boolean;
    warningMessage: string;
    errorMessage: string;
}

export const manageAddToCartError = ({
    code,
    message,
    details,
}: AddToCartIncomingError): AddToCartError => {
    const { existingItems = [] } = details || {};
    const result = {
        isSizeOverlayOpen: false,
        simplesInCart: [] as CartErrorItem[],
        maximumQuantityOfArticleReached: false,
        stockNotFound: false,
        warningMessage: '',
        errorMessage: '',
    };

    switch (code) {
        case ADD_CART_SIZE_SELECTION_WARNING:
            return {
                ...result,
                simplesInCart: existingItems,
                isSizeOverlayOpen: true,
            };
        case ADD_CART_MAX_SIMPLES_PER_CONFIG:
        case ADD_CART_MAX_30_SIMPLES_IN_CART:
            return {
                ...result,
                maximumQuantityOfArticleReached: true,
            };
        case ADD_CART_STOCK_NOT_FOUND:
            return { ...result, stockNotFound: true };
        case ADD_CART_VOUCHER_DISABLED:
            return {
                ...result,
                warningMessage: message,
            };
        case ADD_CART_NOT_COMBINABLE_ADD_ITEM_NOT_COMBINABLE:
        case ADD_CART_NOT_COMBINABLE_NOT_COMBINABLE_IN_CART:
        case ADD_CART_SIZE_SELECTION_ERROR:
        case ADD_CART_MAX_SIMPLES_PER_CONFIG_REACHED_QTY_ADJUSTED:
        case ADD_CART_MAX_AVAILABLE_STOCK_REACHED_QTY_ADJUSTED:
            return { ...result, errorMessage: message };
        default:
            return result;
    }
};
